import React from 'react';
import { TextField, Grid, IconButton, Button, InputLabel } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import styled from 'styled-components';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { formatDate } from '../../../utils/dateFormat';

const FormContainer = styled.div`
  padding: 1rem;
`;

const ExperienceItem = styled.div`
  padding: 1rem;
  margin-bottom: 1rem;
  border: 1px solid #eee;
  border-radius: 4px;
  position: relative;
  
  .quill {
    margin-bottom: 1rem;
    
    .ql-editor {
      min-height: 120px;
    }
  }
`;

const DeleteButton = styled(IconButton)`
  position: absolute;
  top: 0;
  right: 0;
`;

const DateField = styled(TextField)`
  input::-webkit-calendar-picker-indicator {
    display: none;
  }
`;

const modules = {
  toolbar: [
    ['bold', 'italic', 'underline'],
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    ['clean']
  ]
};

const formats = [
  'bold', 'italic', 'underline',
  'list', 'bullet'
];

const ExperienceForm = ({ data = [], onChange }) => {
  const handleAdd = () => {
    onChange([...data, {
      company: '',
      position: '',
      location: '',
      startDate: new Date().toISOString().slice(0, 7),
      endDate: new Date().toISOString().slice(0, 7),
      description: ''
    }]);
  };

  const handleDelete = (index) => {
    onChange(data.filter((_, i) => i !== index));
  };

  const handleChange = (index, field) => (event) => {
    const newData = [...data];
    let value;
    if (field === 'description') {
      value = event;
    } else if (field.includes('Date')) {
      value = event.target.value || new Date().toISOString().slice(0, 7);
    } else {
      value = event.target.value;
    }
    
    newData[index] = {
      ...newData[index],
      [field]: value
    };
    onChange(newData);
  };

  return (
    <FormContainer>
      {data.map((exp, index) => (
        <ExperienceItem key={index}>
          <DeleteButton onClick={() => handleDelete(index)}>
            <DeleteIcon />
          </DeleteButton>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="公司"
                value={exp.company}
                onChange={handleChange(index, 'company')}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="职位"
                value={exp.position}
                onChange={handleChange(index, 'position')}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="地点"
                value={exp.location}
                onChange={handleChange(index, 'location')}
              />
            </Grid>
            <Grid item xs={6}>
              <DateField
                fullWidth
                label="开始日期"
                type="month"
                value={formatDate(exp.startDate) || ''}
                onChange={handleChange(index, 'startDate')}
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  min: "1900-01",
                  max: "2100-12"
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <DateField
                fullWidth
                label="结束日期"
                type="month"
                value={formatDate(exp.endDate) || ''}
                onChange={handleChange(index, 'endDate')}
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  min: "1900-01",
                  max: "2100-12"
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <InputLabel style={{ marginBottom: '0.5rem' }}>工作描述</InputLabel>
              <ReactQuill
                value={exp.description || ''}
                onChange={handleChange(index, 'description')}
                modules={modules}
                formats={formats}
              />
            </Grid>
          </Grid>
        </ExperienceItem>
      ))}
      <Button
        startIcon={<AddIcon />}
        onClick={handleAdd}
        variant="outlined"
        color="primary"
        fullWidth
      >
        添加工作经验
      </Button>
    </FormContainer>
  );
};

export default ExperienceForm; 